// Cầu nối tới extension FunnyTask (qua content script ft-bridge.js).
let reqCounter = 0;

// Gửi yêu cầu đồng bộ, nhận tiến độ qua onProgress, trả về { ok, message, error }.
// signal (tuỳ chọn): AbortSignal — abort để DỪNG (gửi cancel cho extension + ngừng chờ).
export function runSync(action, params = {}, onProgress, signal) {
  return new Promise((resolve) => {
    const reqId = 'ft' + Date.now() + '_' + reqCounter++;
    function cleanup() {
      window.removeEventListener('message', handler);
      if (signal) signal.removeEventListener('abort', onAbort);
    }
    function handler(e) {
      if (e.source !== window || !e.data || e.data.reqId !== reqId) return;
      if (e.data.__ftbridge === 'progress') {
        onProgress && onProgress(e.data.text);
      } else if (e.data.__ftbridge === 'result') {
        cleanup();
        resolve({ ok: e.data.ok, message: e.data.message, error: e.data.error });
      }
    }
    function onAbort() {
      cleanup();
      window.postMessage({ __ftbridge: 'cancel', reqId }, '*'); // báo extension dừng (nếu hỗ trợ)
      resolve({ ok: false, error: 'cancelled', cancelled: true });
    }
    if (signal) {
      if (signal.aborted) return onAbort();
      signal.addEventListener('abort', onAbort);
    }
    window.addEventListener('message', handler);
    window.postMessage({ __ftbridge: 'request', reqId, action, params }, '*');
  });
}

// Kiểm tra extension đã cài + bridge sẵn sàng (ping có timeout).
export function pingExtension(timeoutMs = 1000) {
  return new Promise((resolve) => {
    const reqId = 'ping' + Date.now() + '_' + reqCounter++;
    const t = setTimeout(() => {
      window.removeEventListener('message', h);
      resolve(false);
    }, timeoutMs);
    function h(e) {
      if (e.source === window && e.data && e.data.__ftbridge === 'result' && e.data.reqId === reqId) {
        clearTimeout(t);
        window.removeEventListener('message', h);
        resolve(!!e.data.ok);
      }
    }
    window.addEventListener('message', h);
    window.postMessage({ __ftbridge: 'request', reqId, action: 'ping', params: {} }, '*');
  });
}
